module.exports = __webpack_public_path__ + "img/148.95c506c7.jpg";